// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Axios from 'axios';
import App from './App';
import router from '@/app/router';
import VuexRouterSync from 'vuex-router-sync';
import VeeValidate from 'vee-validate';
import dict from 'vee-validate/dist/locale/nl';
import attr from '@/app/i18n';

import store from '@/app/store';
import plugins from '@/app/plugins';

Vue.use( plugins );
Vue.use( VeeValidate, {
    events: 'input|blur'
});

VeeValidate.Validator.localize( 'nl', Object.assign( dict, attr.nl ) );

VuexRouterSync.sync( store, router );

Axios.defaults.baseURL = window._rootData.apiUrl;
Axios.defaults.headers.common.Accept = 'application/json';
Axios.interceptors.response.use(
    response => response,
    ( error ) =>
    {
        return Promise.reject( error );
    }
);

Vue.$http = Axios;
Object.defineProperty( Vue.prototype, '$http', {
    get()
    {
        return Axios;
    }
});

Vue.config.productionTip = false;

require( 'modern-normalize/modern-normalize.css' );

/* eslint-disable no-new */
new Vue({
    el: '#app',
    store,
    router,
    template: '<App/>',
    components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js